import Column from '@components/Column';
import { EventResponse } from '@models/event';

import styles from './styles.module.scss';

interface Props {
    event: EventResponse;
}

function EventContent({ event }:Props) {
  const { content } = event;
  return (
        <Column fullWidth>
            <div className={styles.wrapper}
                 dangerouslySetInnerHTML={{ __html: content }}/>
        </Column>
  );
}

export default EventContent;
